import { createContext, useContext } from "react";
import { assert } from "utils";

import { type AthletesRepository } from "src/repositories/athletes/AthletesRepository";

export const AthletesRepositoryContext =
  createContext<AthletesRepository | null>(null);

export function useAthletesRepository(): AthletesRepository {
  const repository = useContext(AthletesRepositoryContext);
  assert(repository, "AthletesRepositoryContext is missing");
  return repository;
}
